// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 19) return "static/chunks/19-840984122f7cf8c7.js";
	if (chunkId === 749) return "static/chunks/749-daa3fd298f41d962.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"87":"ec88b2bcb216440a","342":"9f1d9837ad6483f7","380":"0c1482e6783ef71a","703":"45bfa13dcf09c667"}[chunkId] + ".js";
};